import { SearchScenarioId } from 'owa-search-next-common';
import { FlaggedToken, QueryAlterationType } from 'owa-search-service';
import { action } from 'satcheljs';

const setSpellerData = action(
    'setSpellerData',
    (
        alteredQuery: string,
        suggestedSearchTerm: string,
        suggestedSearchTermReferenceId: string,
        flaggedTokens: FlaggedToken[],
        recourseQuery: string,
        scenarioId: SearchScenarioId,
        queryAlterationType: QueryAlterationType
    ) => ({
        alteredQuery,
        suggestedSearchTerm,
        suggestedSearchTermReferenceId,
        flaggedTokens,
        recourseQuery,
        scenarioId,
        queryAlterationType,
    })
);

export default setSpellerData;
